import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <section className="py-20 bg-[#221E3F] text-left">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 text-slate-200">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white">Privacy Policy</h1>

        <p className="mb-4">Effective Date: 18 July 2025</p>

        <p className="mb-4">
          Apoello Limited ("we", "us", or "our") respects your privacy and is committed to protecting any personal data we collect. This Privacy Policy outlines how we handle your personal information when you use our website (www.apoello.com) and submit data through our contact forms.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
        <p className="mb-4">
          When you submit a message via any contact form on our website, we collect:
          <ul className="list-disc pl-5">
            <li>Your name</li>
            <li>Your email address</li>
            <li>Your organisation (if provided)</li>
            <li>The content of your message</li>
          </ul>
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Data</h2>
        <p className="mb-4">
          We use your personal data solely to respond to your enquiry and follow up as needed. We do not use your data for marketing without explicit consent and never sell or share your data with third parties for marketing purposes.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Legal Basis for Processing (UK GDPR)</h2>
        <p className="mb-4">
          Our legal basis for processing your personal data is Legitimate Interest – responding to your enquiry and conducting B2B communications.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Retention</h2>
        <p className="mb-4">
          We retain your data for up to 12 months from the date of submission unless legally required to retain it longer.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Data Security and International Transfers</h2>
        <p className="mb-4">
          We implement appropriate measures to protect your personal data, including secure form submissions via our form service provider (Formspree) and secure hosting via AWS Amplify.
        </p>
        <p className="mb-4">
          Please note that some data may be processed outside the UK/EU, including in the United States. Where such transfers occur, we rely on appropriate safeguards, such as Standard Contractual Clauses, to protect your data in compliance with UK GDPR.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Use of Data Processors</h2>
        <p className="mb-4">
          We may share your data with trusted service providers, such as Formspree (for contact form submissions) and AWS Amplify (for website hosting), solely to facilitate the functioning of our website. These processors are contractually bound to protect your data.
        </p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Cookies and Embedded Content</h2>
        <p className="mb-4">
          Our website uses strictly necessary cookies for essential functionality and security. No advertising or tracking cookies are actively deployed by us directly.
        </p>
        <p className="mb-4">
          Please note that we embed YouTube videos on our website. Although we use YouTube’s privacy-enhanced mode, YouTube may still set cookies upon loading the video frame, even if you do not play the video. These cookies are set by YouTube/Google and are outside our direct control.
        </p>
        <p className="mb-4">
          You can manage cookies via your browser settings, including blocking third-party cookies or clearing existing cookies manually. Most browsers offer cookie control options.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Your Rights</h2>
        <p className="mb-4">
          You have the right to access, correct, or delete your data at any time. To exercise these rights, contact us at contact@apoello.com.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Information</h2>
          <p className="mb-4">
            Apoello Limited<br />
            16 Conway Road, Eccleston, Chorley, PR7 5SW<br />
            United Kingdom<br />
            Company Registration Number: 16339273 (Registered in England and Wales)<br />
            Email: contact@apoello.com
          </p>


        <h2 className="text-2xl font-semibold mt-8 mb-4">10. Updates to This Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. The latest version will always be available on our website.
        </p>

        <p className="mt-8">
          By submitting a form on our website, you acknowledge this Privacy Policy and agree to its terms.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
